import * as XLSX from 'xlsx';

export const DownloadExcelTemplate = () => {
    // Data for the main sheet
    const data = [
        ["Nombre y Apellido", "WhatsApp", "Distrito", "SKU", "Cantidad", "Producto", "Cobrar", "Fecha", "Notas", "Direccion"],
        ["John Doe", "912345678", "Miraflores", "FAJA-001", "2", "Faja Clásica", "89.90", "01/15/2025", "Ejemplo de nota", "Av. Ejemplo 123"],
        ["Maria Garcia", "987654321", "San Isidro", "CINT-002", "1", "", "45.00", "01/16/2025", "Llamar antes", "Jr. Los Pinos 456"]
    ];

    // Instructions
    const instructions = [
        ["INSTRUCCIONES IMPORTANTES:"],
        [""],
        ["📋 CAMPOS OBLIGATORIOS:"],
        ["• Nombre y Apellido: Nombre completo del destinatario"],
        ["• WhatsApp: Exactamente 9 dígitos (sin código de país +51)"],
        ["• Distrito: Debe coincidir exactamente con la lista de distritos"],
        ["• Fecha: Formato DD/MM/AAAA (Ejemplo: 15/01/2025)"],
        ["• Direccion: Dirección completa de entrega"],
        [""],
        ["🏷️ CAMPOS DE PRODUCTO (al menos uno es obligatorio):"],
        ["• SKU: Código del producto (RECOMENDADO - más preciso)"],
        ["• Producto: Descripción del producto (opcional si hay SKU)"],
        [""],
        ["📦 CAMPOS OPCIONALES:"],
        ["• Cantidad: Número de unidades (por defecto: 1)"],
        ["• Cobrar: Monto a cobrar contraentrega (por defecto: 0)"],
        ["• Notas: Información adicional para el courier"],
        [""],
        ["⚠️ NOTAS IMPORTANTES:"],
        ["• Si proporciona SKU, el sistema usará el precio registrado del producto"],
        ["• Si no proporciona SKU, debe llenar el campo 'Producto' con descripción"],
        ["• La columna 'Cantidad' solo aplica cuando se proporciona un SKU"],
        ["• Verifique que el SKU exista en el inventario antes de subir"],
        [""],
        ["📍 DISTRITOS DISPONIBLES:"],
        ["Copie exactamente el nombre del distrito de la lista en la pestaña 'Distritos'"]
    ];

    const districts = [
        "Ate", "Barranco", "Breña", "Carabayllo", "Chaclacayo", "Chorrillos",
        "Cieneguilla", "Comas", "El Agustino", "Independencia", "Jesús María",
        "La Molina", "La Victoria", "Lince", "Los Olivos", "Lurigancho", "Lurin",
        "Magdalena del Mar", "Miraflores", "Pachacamac", "Pueblo Libre", "Puente Piedra",
        "Rimac", "San Borja", "San Isidro", "San Juan de Lurigancho", "San Juan de Miraflores",
        "San Luis", "San Martin de Porres", "San Miguel", "Santa Anita", "Santiago de Surco",
        "Surquillo", "Villa El Salvador", "Villa Maria del Triunfo", "Cercado de Lima",
        "Callao", "Bellavista", "Carmen de La Legua Reynoso", "La Perla", "La Punta", "Ventanilla"
    ];

    const districtSheetData = [
        ["LISTA DE DISTRITOS VÁLIDOS"],
        [""],
        ["⚠️ Copie el nombre EXACTAMENTE como aparece aquí:"],
        [""],
        ...districts.map(district => [district])
    ];

    // SKU examples sheet
    const skuExamples = [
        ["EJEMPLOS DE SKU Y PRODUCTOS"],
        [""],
        ["SKU", "Producto", "Precio", "Descripción"],
        ["FAJA-001", "Faja Clásica Negra", "89.90", "Faja reductora de cintura"],
        ["FAJA-002", "Faja Premium Beige", "129.90", "Faja con compresión alta"],
        ["CINT-001", "Cinturón Deportivo M", "45.00", "Cinturón para ejercicio"],
        ["CINT-002", "Cinturón Deportivo L", "45.00", "Cinturón para ejercicio talla L"],
        [""],
        ["💡 CONSEJOS:"],
        ["• Contacte a su administrador para obtener la lista completa de SKUs"],
        ["• Verifique que el SKU esté activo en el inventario"],
        ["• Use SKU en lugar de 'Producto' para mayor precisión"],
        ["• Si usa SKU, el campo 'Producto' puede dejarse vacío"]
    ];

    // Convert data to sheets
    const wsData = XLSX.utils.aoa_to_sheet(data);
    const wsInstructions = XLSX.utils.aoa_to_sheet(instructions);
    const wsDistricts = XLSX.utils.aoa_to_sheet(districtSheetData);
    const wsSKU = XLSX.utils.aoa_to_sheet(skuExamples);

    // Set column widths for better readability
    wsData['!cols'] = [
        { wch: 20 }, // Nombre
        { wch: 12 }, // WhatsApp
        { wch: 20 }, // Distrito
        { wch: 12 }, // SKU
        { wch: 10 }, // Cantidad
        { wch: 25 }, // Producto
        { wch: 10 }, // Cobrar
        { wch: 12 }, // Fecha
        { wch: 30 }, // Notas
        { wch: 35 }  // Direccion
    ];

    wsInstructions['!cols'] = [{ wch: 80 }];
    wsDistricts['!cols'] = [{ wch: 40 }];
    wsSKU['!cols'] = [{ wch: 15 }, { wch: 25 }, { wch: 10 }, { wch: 35 }];

    // Create workbook and append sheets
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsData, "Plantilla");
    XLSX.utils.book_append_sheet(wb, wsInstructions, "Instrucciones");
    XLSX.utils.book_append_sheet(wb, wsDistricts, "Distritos");
    XLSX.utils.book_append_sheet(wb, wsSKU, "Ejemplos SKU");

    // Write file
    XLSX.writeFile(wb, "Plantilla_Carga_Masiva_FastMax.xlsx");
};